<template>
  <div class="container mx-auto overflow-x-hidden">
    <div class="skeleton-wrapper flex gap-2 lg:gap-5 md:w-fit">
      <div class="flex-1 flex flex-col md:hidden">
        <n-skeleton class="rounded w-full h-full" />
        <n-skeleton class="rounded w-10% h-6 mt-4 mb-6 flex-none" text />
      </div>
      <div class="w-[calc(100%-40px)] sm:w-134 flex flex-col md:hidden">
        <n-skeleton class="rounded w-full h-full aspect-2.67" />
        <n-skeleton class="rounded w-70% h-6 mt-4 mb-6 flex-none" text />
      </div>
      <div class="flex-1 flex flex-col md:hidden">
        <n-skeleton class="rounded w-full h-full" />
        <n-skeleton class="rounded w-full h-6 mt-4 mb-6 flex-none" text />
      </div>
      <div v-for="i in 3" :key="i" class="w-[calc(100%-40px)] md:w-134 hidden md:flex md:flex-col">
        <n-skeleton class="rounded w-full h-full aspect-2.67" />
        <n-skeleton class="rounded w-70% h-6 mt-4 mb-6 flex-none" text />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { NSkeleton } from 'naive-ui'
</script>
